module.exports = __webpack_public_path__ + "static/media/324.39993e55.webp";